export const levels = {
  info: 'info',
  warning: 'warning',
  danger: 'danger'
}

export const types = {
  info: 200000000,
  warning: 200000002,
  danger: 200000001
}

export const typeMapper = {
  [types.info]: levels.info,
  [types.warning]: levels.warning,
  [types.danger]: levels.danger
}

export const backgroundMapper = {
  [types.warning]: { inActive: '#fad668', active: '#fabe07' },
  [types.danger]: { inActive: '#e38a93', active: '#dc3545' },
}

export function getBackgroundColor (status: number, top = false) {
  if (status && !backgroundMapper[status]) throw Error('Unknown status: ' + status)

  if (!status && !top) return backgroundMapper[types.warning].inActive
  if (!status && top) return backgroundMapper[types.warning].active
  return backgroundMapper[status][top ? 'active' : 'inActive']
}
